import Client from './client';

export default class Channels extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/channels`, options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/internal/channels`, {
      ...options,
       method: 'POST',
    });
  }

  getByChannelId(channelId, options = {}) {
    return this.makeRequest(`${this.host}/internal/channels/${channelId}`, options);
  }

  putByChannelId(channelId, options = {}) {
    return this.makeRequest(`${this.host}/internal/channels/${channelId}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByChannelId(channelId, options = {}) {
    return this.makeRequest(`${this.host}/internal/channels/${channelId}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
